import { mapActions } from "vuex";
import moment from "moment";
export default {
    name: "outBillOrderInfo",
    data() {
        return {
            permissions: {
                OverExportDetail: false    //导出
			},
            outBill: {
                //
                billDate: [],
                billState: null,
            },
            localBillCache: {},
            pageLoading: false,
            pageData: [],

            // billStateList:[
            //     {
            //         value:null,
            //         label: '全部'
            //     },
            //     {
            //         value: 0,
            //         label: '未对账'
            //     },
            //     {
            //         value: 1,
            //             label: '已对账'
            //     },
            //     {
            //         value: 4,
            //             label: '已付款'
            //     },
            // ],
            // pageLoading:false,
            // showOutBillInfo:false,
            // pageData:[],
            pageBase2: {
                pageSizes: [10, 20, 30, 40, 50, 100],
                pageSize: 10,
                pageNumber: 1,
                total: 0
            },
            tableColunm: [
                {
                    prop: 'orderId',
                    label: '订单号',
                    width: 200
                },
                {
                    prop: 'transportFee',
                    label: '运费(元)',
                    width: 200, 
                    formatter: function (row, column) {
                        return row.transportFee;
                    }
                },

                {
                    prop: 'loadWaitFee',//运费，确认订单金额是不是就是运费
                    label: '装车等待费（元）',
                    width: 140,
                    formatter: function (row, column) {
                         return row.loadWaitFee ;
                    }

                },
                {
                    prop: 'unLoadWaitFee',//运费，确认订单金额是不是就是运费
                    label: '卸车等待费（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.unLoadWaitFee ;
                    }

                },
                {
                    prop: 'emptyFee',//运费，确认订单金额是不是就是运费
                    label: '空置费（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.emptyFee ;
                    }
                },
                {
                    prop: 'adjustDeductFee',//运费，确认订单金额是不是就是运费
                    label: '调整补扣费（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.adjustDeductFee ;
                    }
                },
                {
                    prop: 'byCarLaterFee',//运费，确认订单金额是不是就是运费
                    label: '靠卡晚点（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.byCarLaterFee ;
                    }
                },
                {
                    prop: 'ponchosFee',//运费，确认订单金额是不是就是运费
                    label: '雨布费（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.ponchosFee ;
                    }
                },
                {
                    prop: 'warehouseUnLoadFee',//运费，确认订单金额是不是就是运费
                    label: '仓库卸货费（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.warehouseUnLoadFee ;
                    }
                },
                {
                    prop: 'runTimeoutFee',//运费，确认订单金额是不是就是运费
                    label: '运行超时（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.runTimeoutFee ;
                    }
                },
                {
                    prop: 'otherFee',
                    label: '其他费用（元）',
                    width: 200,
                    formatter: function (row, column) {
                        return row.otherFee ;
                    }
                }, 
                {
                    prop: 'totalFee',
                    label: '合计应付(含税:元)',
                    width: 200, formatter: function (row, column) {
                        return row.totalFee;
                    }
                },
                {
                    prop: 'startCityName',
                    label: '发货城市',
                    width: 200
                }, {
                    prop: 'destCityName',
                    label: '收货城市',
                    width: 200
                }, {
                    prop: 'cargoTypeName',
                    label: '货物信息',
                    width: 200
                }, {
                    prop: 'lineMileage',
                    label: '线路里程（KM）',
                    width: 200,
                    formatter: function (row, column) {
                        if (row.lineMileage) {
                            return row.lineMileage ;
                        }

                        return null;
                    }
                },
                {
                    prop: 'vehiclePlate',
                    label: '车牌',
                    width: 160
                },
                {
                    prop: 'vehicleType',
                    label: '车型/车长',
                    width: 160,
                    formatter: function (row, column) {
                        if (row.vehicleType) {
                            return row.vehicleType + '/' + row.vehicleLength +'m' ;
                        }

                        return null;
                    }
                },

                {
                    prop: 'actualCarrier',
                    label: '实际承运对象',
                    width: 160
                }, 
                {
                    label: '发车时间',
                    width: 260,
                    formatter: function (row, column) {
                        return <div><div>计划发车： {row.planDepartTime?row.planDepartTime:'-'} </div><div>实际发车： {row.actualDepartTime?row.actualDepartTime:'-'}</div>  </div> 
                    }
                },
                {
                    label: '到车时间',
                    width: 260,
                    formatter: function (row, column) {
                        return <div><div>计划到车： {row.planArriveTime?row.planArriveTime:'-'} </div><div>实际到车： {row.actualArriveTime?row.actualArriveTime:'-'}</div>  </div> 
                    }
                },
                {
                    prop: 'paymentDaysTime',
                    label: '账期归属时间',
                    width: 200
                },
                {
                    prop: 'contractSubjectName',
                    label: '签约主体',
                    width: 260
                }, 
                {
                    prop: 'orderBelongName',
                    label: '订单归属',
                    width: 260
                }, {
                    prop: 'waybillId',
                    label: '客户运单号',
                    width: 200
                }, {
                    prop: 'createTime',
                    label: '创建时间',
                    width: 160
                }
            ]

        }
    }, methods: {
        selectionChange(val) {
            this.multipleSelection = val;
        },
        ...mapActions([
            "queryRowInfo",
            "uploadTOdownDetail",
        ]),
        queryOutbillInfoPage(no) {
            this.pageBase2.pageNumber = 1;
            this.queryPageBase(no);
        },
        exportOutbillShipInfo() {
            let param = {
                "billNo": this.localBillCache.billNo,
                "pageSize": 10000,
                "pageNumber": 1
            }
            this.uploadTOdownDetail(param).then(res => {
                window.open(this.getHostUrl() + "/saas/shipperOrderController/downLoadFile?objectName=" + res)
            }).catch(e => {

            });
        },
        getHostUrl() {
            return location.protocol + "//" + location.host;
        },
        queryPageBase(no) {
            let param = {
                "billNo": no,
                "pageSize": this.pageBase2.pageSize,
                "pageNumber": this.pageBase2.pageNumber
            }
            this.queryRowInfo(param).then(res => {
                this.pageData = res.dataList;
                this.pageBase2.total = res.totalSize;

            }).catch(e => { });
        },

        sizeChange(val) {
            this.pageBase2.pageSize = val;
            this.pageBase2.pageNumber = 1;
            this.queryPageBase(this.localBillCache.billNo);
        },
        currentChange(val) {
            this.pageBase2.pageNumber = val;
            this.queryPageBase(this.localBillCache.billNo);
        },
        initBillData() {
            let outBillRowData = window.sessionStorage.getItem('outBillRowData');
            if (outBillRowData) {
                let tmp = JSON.parse(outBillRowData);
                //放入缓存
                this.localBillCache = tmp
                window.sessionStorage.removeItem('outBillRowData');
            }
        },
        mapBillStatus(val){
            if (val == 1) {
                return '未对账';
            } else if (val == 2) {
                return '已对账';
            } else if (val == 3) {
                return '扣款中';
            } else if (val == 4) {
                return '付款中';
            } else if (val == 5) {
                return '已结清';
            } else if (val == 6) {
                return '已废弃';
            }
        },
    },

    watch: {
         
    },
    created: function () {
        this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
        this.initBillData();
        if(this.localBillCache && this.localBillCache.billNo){
            this.queryOutbillInfoPage(this.localBillCache.billNo);
        }
        // let routerParams = this.$route.params.id
        // alert(routerParams)
        // // 将数据放在当前组件的数据内
        //         alert(routerParams)
    }
    ,
};